/* eslint-disable @typescript-eslint/ban-types */
export const handlerDecorator = (handler) => {
    return handlerDecorator._impl(handler);
};
handlerDecorator._impl = (handler) => handler;
handlerDecorator.setup = (impl) => {
    handlerDecorator._impl = impl;
};
//# sourceMappingURL=handlerDecorator.js.map